import { render, staticRenderFns } from "./ConsumeInfoForm.vue?vue&type=template&id=5837b0b6&"
import script from "./ConsumeInfoForm.vue?vue&type=script&lang=js&"
export * from "./ConsumeInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports